import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ClusterGraph from '../components/ClusterGraph';
import './ClusterView.css';

const ClusterView = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { clusterData, dataset, treasure } = location.state;

    if (!clusterData) {
        return <div>No cluster data available</div>;
    }

    return (
        <div className="cluster-view-container">
            <div className="cluster-header">
                <button 
                    className="back-button"
                    onClick={() => navigate(-1)}
                >
                    ← Return
                </button>
                <h1>Cluster Analysis - {treasure} --{'>'} {dataset}</h1>
            </div>
            <div className="cluster-content">
                <ClusterGraph clusterData={clusterData} />
            </div>
        </div>
    );
};

export default ClusterView;